import React from "react"
import { createStyles, makeStyles } from "@material-ui/core/styles"
import { UserCard, IUserCardGroup, IUserCardsSection } from "shared/Modules/UserCards/userCardsTypes"
import { useUserSurveyModal } from "shared/Modules/Surveys/userSurveyHooks"
import { useDetailedReceiptModal } from "./components/detailedReceiptHook"
import { Section } from "shared/Components/Skeleton/Section"
import CardCarousel from "mobile/Components/CardCarousel"
import { UserCardFactory } from "./UserCardFactory"

const useStyles = makeStyles(() =>
    createStyles({
        cardCarousel: {
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
        },
    })
)

interface IUserCardSectionsProps {
    sections: IUserCardsSection[]
    containerClassName?: string
}

export function UserCardSections(props: IUserCardSectionsProps) {
    const { sections, containerClassName } = props
    const classes = useStyles({})
    const { UserSurveyModalAdapter, showSurveyModal } = useUserSurveyModal()
    const { DetailedReceiptModalAdapter, showDetailedReceiptModal } = useDetailedReceiptModal()

    return sections.length ? (
        <>
            {sections.map((section: IUserCardsSection) => {
                return (
                    <Section key={section.id} title={section.title} className={containerClassName}>
                        <div className={classes.cardCarousel}>
                            {section.groups.map((group: IUserCardGroup, index: number) => {
                                return (
                                    <CardCarousel key={`group_${index}`}>
                                        {group.cards.map((card: UserCard) => {
                                            return (
                                                <UserCardFactory
                                                    key={card.id}
                                                    card={card}
                                                    showSurveyModal={showSurveyModal}
                                                    showDetailedReceiptModal={showDetailedReceiptModal}
                                                />
                                            )
                                        })}
                                    </CardCarousel>
                                )
                            })}
                        </div>
                    </Section>
                )
            })}
            <UserSurveyModalAdapter />
            <DetailedReceiptModalAdapter />
        </>
    ) : null
}

export default React.memo(UserCardSections)
